import { SLOW_NETWORK_DOWNLINK } from './constants';
import { isNetworkMetered } from './isNetworkMetered';
/**
 * If true, the user's browser is telling us their connection is slow.
 *
 * This only works on some browsers that tell us what their downlink
 * speed is. See the mozilla docs for more info:
 * https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
 */
export const isNetworkSlow = () => {
    var _a, _b;
    return isNetworkMetered() ||
        //@ts-ignore // This property does exist on some browsers
        (((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.downlink) !== undefined &&
            //@ts-ignore // This property does exist on some browsers
            window.navigator.connection.downlink < SLOW_NETWORK_DOWNLINK);
};
